import { render } from "./CustomerDetails.vue?vue&type=template&id=248e8266&scoped=true"
import script from "./CustomerDetails.vue?vue&type=script&lang=js"
export * from "./CustomerDetails.vue?vue&type=script&lang=js"

import "./CustomerDetails.vue?vue&type=style&index=0&id=248e8266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248e8266"]])

export default __exports__